.item {
  cursor: pointer;
}
